import React from 'react';
import Styled from './Card.style';
import {
  ChartBars,
  ChartBarNegative,
  ChartMultiBars,
  Typography,
} from '../index';
import { ChartData } from '../../interfaces';
import { useTranslation } from 'react-i18next';

interface CardProps {
  id: number;
  title: string;
  rows: Array<any>;
  subTitle?: string;
  type: string;
  theme?: string | undefined;
  chartData: ChartData;
  desc: string;
  style?: React.CSSProperties;
  isDesktop?: boolean;
  displayMoney?: string;
}

const Card: React.FC<CardProps> = (props) => {
  const {
    title,
    theme,
    id,
    type,
    chartData,
    isDesktop,
    displayMoney,
    subTitle,
  } = props;
  const [t] = useTranslation('common');

  const renderRows = () => {
    switch (type) {
      case 'chart-bar':
        return (
          <ChartBars
            id={id}
            title={t(title)}
            key={id}
            theme={theme}
            displayMoney={displayMoney}
            chartData={chartData}
          />
        );
      case 'chart-multi-bar':
        return (
          <ChartMultiBars
            id={id}
            key={id}
            theme={theme}
            chartData={chartData && chartData}
          />
        );
      case 'chart-bar-negative':
        return (
          <ChartBarNegative
            id={id}
            title={t(`${title}`)}
            key={id}
            displayMoney={displayMoney}
            theme={theme}
            chartData={chartData}
          />
        );
      default:
        return <div key={id}>{type} doesnt exist</div>;
    }
  };
  const text_translation_title = t(title);
  const text_translation_subTitle = subTitle && t(subTitle);
  return (
    <Styled.Card
      className="card"
      isDesktop={isDesktop}
      data-test="Card"
      id={`card-${id}`}
    >
      <Typography
        size="4"
        weight={600}
        style={{ textAlign: 'center', fontSize: '20px' }}
        text={text_translation_title}
        data-test="title"
      />
      {subTitle && (
        <Typography
          size="p"
          style={{
            textAlign: 'center',
            fontSize: '18px',
            marginBottom: '32px',
          }}
          weight={400}
          text={text_translation_subTitle}
        />
      )}
      {renderRows()}
    </Styled.Card>
  );
};

export default Card;
